import { AccountBalance, SubPartnerAccount } from 'vopay';

/**
 * The status an account — or a partner account, which shares the rule — is in, as the portal reads
 * it: Blocked overrides everything, an active one is Active, otherwise the onboarding status the
 * API reports (null for a partner account with no recorded stage). The status badge and anything
 * that gates on "is this account usable" must agree, so both read it from here.
 */
export default function derivePartnerAccountStatus(
  account: Pick<AccountBalance | SubPartnerAccount, 'AccountStatus' | 'IsActive'>,
) {
  if (account.AccountStatus === 'Blocked') return 'Blocked';

  return account.IsActive ? 'Active' : account.AccountStatus;
}
